const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  cancelButton: {
    backgroundColor: 'white',
    color: 'primary.main',
    border: '1px solid',
    borderColor: 'semiGray',
    flex: 'none',
    '&:hover': {
      color: 'white',
    },
  },
}

export default styles;
